<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  formData: {
    name: string;
    description: string;
    action: {
      type: string;
    };
  };
}

const props = defineProps<Props>();
const emit = defineEmits<{
  'update:formData': [value: any];
}>();

const formData = computed({
  get: () => props.formData,
  set: (value) => emit('update:formData', value)
});
</script>

<template>
  <div class="space-y-4">
    <!-- Basic Info -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Nombre de la Promoción
        </label>
        <input
          :value="formData.name"
          type="text"
          required
          class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
          @input="formData.name = ($event.target as HTMLInputElement).value"
        >
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Descripción
        </label>
        <input
          :value="formData.description"
          type="text"
          class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
          @input="formData.description = ($event.target as HTMLInputElement).value"
        >
      </div>
    </div>

    <!-- Promotion Type -->
    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Tipo de Promoción
      </label>
      <select
        :value="formData.action.type"
        required
        class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
        @change="formData.action.type = ($event.target as HTMLSelectElement).value"
      >
        <option value="">
          Seleccionar tipo
        </option>
        <option value="buy_x_get_y">
          Compra X obtén Y
        </option>
        <option value="fixed_price">
          Precio Fijo
        </option>
        <option value="percentage_discount">
          Descuento Porcentual
        </option>
        <option value="fixed_amount_discount">
          Descuento Fijo
        </option>
        <option value="free_item">
          Item Gratis
        </option>
        <option value="bundle_price">
          Paquete Especial
        </option>
        <option value="buy_x_for_y_price">
          Compra X cantidad por Y precio
        </option>
      </select>
    </div>
  </div>
</template>
